export const jobTypeList = [
  {
    id: 3101,
    checked: false,
    label: 'Full Time',
  },
  {
    id: 3102,
    checked: false,
    label: 'Part Time',
  },
  {
    id: 3103,
    checked: false,
    label: 'Internship',
  },
  {
    id: 3104,
    checked: false,
    label: 'Contract',
  },
  {
    id: 3105,
    checked: false,
    label: 'Other',
  },
];

export const salaryList = [

  {
    id: 311,
    checked: false,
    low: 0,
    high: 500,
    label: '0 - $500',
  },
  {
    id: 312,
    checked: false,
    low: 501,
    high: 1000,
    label: '$501 - $1000',
  },
  {
    id: 313,
    checked: false,
    low: 1001,
    high: 1500,
    label: '$1001 - $1500',
  },
  {
    id: 314,
    checked: false,
    low: 1501,
    high: 999999999999,
    label: '$1501 to ꝏ',
  },
];


export const contactData = [
  {
    id: 2001,
    location: 'HQ - San Mateo, CA',
    street: '2950 S. Delaware Street, Suite 201 San Mateo CA 94403',
    contactNum: '+1 650 513 0514',
    availability: '(Mon-Fri) 9AM to 5PM PST'
  },
  {
    id: 2002,
    location: 'Bangalore, India',
    street: 'Tower B, 5th floor,CoWrks New Indiranagar NSW 2000',
    contactNum: '+91 44 6667 8080',
    availability: '(Mon-Fri) 9AM to 5PM IST'
  },
  {
    id: 2003,
    location: 'Melbourne, Australia',
    street: 'Level 22, 120 Spencer Street,Melbourne VIC 3000',
    contactNum: '1800 934 033',
    availability: '(Mon-Fri) 9AM to 5PM AEST'
  },
  {
    id: 2004,
    location: 'Hyderabad, India',
    street: 'Phoenix Primea, Block C , Financial District, New Indiranagar',
    contactNum: '1800 934 033',
    availability: '(Mon-Fri) 9AM to 5PM IST'
  },
  {
    id: 2005,
    location: 'Berlin, Germany',
    street: 'Neue Grünstraße 17, 10179 Berlin,Rd Number 2, Germany',
    contactNum: '1800 934 033',
    availability: '(Mon-Fri) 9AM to 5PM CEST'
  },
  {
    id: 2006,
    location: 'Paris, France',
    street: 'WeWork,92 Av. des Champs-Élysées,75008 Paris, France',
    contactNum: '5874 5849 58',
    availability: '(Mon-Fri) 9AM to 5PM CEST'
  },
]

export const teamMemberData = [
  {
    id: 1111,
    name: 'Emtiaz Hossain Emon',
    photoUrl: 'https://i.ibb.co/kJ25qtZ/Emtiaz-Emon.jpg',
    linkedinUrl: 'https://www.linkedin.com/in/emtiazhossaine2/',
    githuburl: 'https://github.com/EmtiazHossainE2',
    portfolioUrl: 'https://emtiaz-emon.netlify.app/'
  },
  {
    id: 1112,
    name: 'Arefin Khan',
    photoUrl: 'https://i.ibb.co/jkKGmVG/Arefin.jpg',
    linkedinUrl: 'https://www.linkedin.com/in/arefinkhan007/',
    githuburl: 'https://github.com/TEMPLAR-007',
    portfolioUrl: 'https://arefins-portfolio.netlify.app/'
  },
  {
    id: 1113,
    name: 'Toufiq Hasan Kiron',
    photoUrl: 'https://i.ibb.co/pjjtpQW/Kiron.jpg',
    linkedinUrl: 'https://www.linkedin.com/in/toufiq-hasan-kiron/',
    githuburl: 'https://github.com/kiron0',
    portfolioUrl: 'https://toufiqhasan.me'
  },
  {
    id: 1114,
    name: 'Shawon Mondal Gopal',
    photoUrl: 'https://i.ibb.co/mydD3QS/Shawon.jpg',
    linkedinUrl: 'https://www.linkedin.com/in/shawon-mondal-gopal-597904209/',
    githuburl: 'https://github.com/shawon-MG',
    portfolioUrl: 'https://shawon-web-developer-portfolio.netlify.app/#main-projects'
  },
  {
    id: 1115,
    name: 'Sajal Howlader',
    photoUrl: 'https://i.ibb.co/WB1qTd1/Sajal.jpg',
    linkedinUrl: 'https://www.linkedin.com/in/sajal-howlader-01911a241/',
    githuburl: 'https://github.com/Sajalhowlader',
    portfolioUrl: 'https://portfolio-231de.web.app/'
  },
  {
    id: 1116,
    name: 'NAZMUL HASSAN',
    photoUrl: 'https://i.ibb.co/g64cgyV/Nazmul.png',
    linkedinUrl: 'https://www.linkedin.com/in/nazmul-h',
    githuburl: 'https://github.com/nazmul162001',
    portfolioUrl: 'https://portfolio-c8ad1.web.app/'
  },

]
